import { format, startOfToday } from 'date-fns';

import { setDailyrentActionType } from 'shared/actions/dailyrentActionType';
import { EDailyrentBookingCalendarActionTypes } from 'shared/actions/dailyrentBookingCalendar/types';
import { deleteDailyrentQueryParams } from 'shared/containers/BookingCalendarInputContainer/helpers';
import { selectOfferId } from 'shared/selectors/offerData/offer/selectOfferId';
import { fetchGuestCalendar } from 'shared/services/fetchGuestCalendar';
import { IThunkActionCreator } from 'shared/store';
import { ICalendarDayData } from 'shared/types/bookingCalendar';
import { EActionType } from 'shared/types/dailyrent';
import { actionGenerator } from 'shared/utils/redux/actionGenerator';

const setCalendarOpen = actionGenerator<EDailyrentBookingCalendarActionTypes.SetCalendarOpen, boolean>(
  EDailyrentBookingCalendarActionTypes.SetCalendarOpen,
);

export const openCalendarModal = () => setCalendarOpen(true);
export const closeCalendarModal = () => setCalendarOpen(false);

const setDaysAvailability = actionGenerator<
  EDailyrentBookingCalendarActionTypes.SetDaysAvailability,
  ICalendarDayData[]
>(EDailyrentBookingCalendarActionTypes.SetDaysAvailability);

const setInitialLoading = actionGenerator<EDailyrentBookingCalendarActionTypes.SetInitialLoading, boolean>(
  EDailyrentBookingCalendarActionTypes.SetInitialLoading,
);

export const setError = actionGenerator<EDailyrentBookingCalendarActionTypes.SetError, string>(
  EDailyrentBookingCalendarActionTypes.SetError,
);

export const setDates = actionGenerator<
  EDailyrentBookingCalendarActionTypes.SetDates,
  { from: string | undefined; to: string | undefined }
>(EDailyrentBookingCalendarActionTypes.SetDates);

/** Запрашивает календарь доступности */
export const loadAvailability = (): IThunkActionCreator<Promise<void>> => async (dispatch, getState, context) => {
  const state = getState();
  const offerRealtyId = selectOfferId(state);
  const today = startOfToday();
  const startDate = format(today, 'yyyy-MM-dd');

  dispatch(setInitialLoading(true));

  try {
    const calendar = await fetchGuestCalendar(context, { offerRealtyId, start: startDate });
    dispatch(setDaysAvailability(calendar));
  } catch (err) {
    dispatch(setError(err.message));
  } finally {
    dispatch(setInitialLoading(false));
  }
};

/** Базовая очистка дат: обнуляет redux dates/error и удаляет checkin/checkout из URL. */
export const clearBookingDates = (): IThunkActionCreator => dispatch => {
  dispatch(setDates({ from: undefined, to: undefined }));
  dispatch(setError(''));
  const newUrl = deleteDailyrentQueryParams(window.location.href, ['checkin', 'checkout']);
  history.replaceState(undefined, '', newUrl);
};

/** Пользовательский сброс дат из календаря переводит CTA обратно в проверку дат. */
export const resetBookingDatesFromCalendar = (): IThunkActionCreator => dispatch => {
  dispatch(clearBookingDates());
  dispatch(setDailyrentActionType(EActionType.OtaCheckDates));
};
